'use strict';

var _classCallCheck = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';

function getDefaultBase() {
  if (isReactNative) {
    return 'http://localhost';
  } // in some environments i.e. cloudflare workers location is not available


  if (!self.location) {
    return '';
  }

  return self.location.protocol + '//' + self.location.host;
}

var URL = self.URL;
var defaultBase = getDefaultBase();

var URLWithLegacySupport = /*#__PURE__*/function () {
  function URLWithLegacySupport() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBase;

    _classCallCheck(this, URLWithLegacySupport);

    this.super = new URL(url, base);
    this.path = this.pathname + this.search;
    this.auth = this.username && this.password ? this.username + ':' + this.password : null;
    this.query = this.search && this.search.startsWith('?') ? this.search.slice(1) : null;
  }

  _createClass(URLWithLegacySupport, [{
    key: "hash",
    get: function get() {
      return this.super.hash;
    },
    set: function set(hash) {
      this.super.hash = hash;
    }
  }, {
    key: "host",
    get: function get() {
      return this.super.host;
    },
    set: function set(host) {
      this.super.host = host;
    }
  }, {
    key: "hostname",
    get: function get() {
      return this.super.hostname;
    },
    set: function set(hostname) {
      this.super.hostname = hostname;
    }
  }, {
    key: "href",
    get: function get() {
      return this.super.href;
    },
    set: function set(href) {
      this.super.href = href;
    }
  }, {
    key: "origin",
    get: function get() {
      return this.super.origin;
    }
  }, {
    key: "password",
    get: function get() {
      return this.super.password;
    },
    set: function set(password) {
      this.super.password = password;
    }
  }, {
    key: "pathname",
    get: function get() {
      return this.super.pathname;
    },
    set: function set(pathname) {
      this.super.pathname = pathname;
    }
  }, {
    key: "port",
    get: function get() {
      return this.super.port;
    },
    set: function set(port) {
      this.super.port = port;
    }
  }, {
    key: "protocol",
    get: function get() {
      return this.super.protocol;
    },
    set: function set(protocol) {
      this.super.protocol = protocol;
    }
  }, {
    key: "search",
    get: function get() {
      return this.super.search;
    },
    set: function set(search) {
      this.super.search = search;
    }
  }, {
    key: "searchParams",
    get: function get() {
      return this.super.searchParams;
    }
  }, {
    key: "username",
    get: function get() {
      return this.super.username;
    },
    set: function set(username) {
      this.super.username = username;
    }
    /**
     * @param {any} o
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.super.toJSON();
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.super.toString();
    }
  }, {
    key: "format",
    value: function format() {
      return this.toString();
    }
  }], [{
    key: "createObjectURL",
    value: function createObjectURL(o) {
      return URL.createObjectURL(o);
    }
    /**
     * @param {string} o
     */

  }, {
    key: "revokeObjectURL",
    value: function revokeObjectURL(o) {
      URL.revokeObjectURL(o);
    }
  }]);

  return URLWithLegacySupport;
}();
/**
 * @param {string | import('url').UrlObject} obj
 */


function format(obj) {
  if (typeof obj === 'string') {
    var url = new URL(obj);
    return url.toString();
  }

  if (!(obj instanceof URL)) {
    var userPass = // @ts-ignore its not supported in node but we normalise
    obj.username && obj.password // @ts-ignore its not supported in node but we normalise
    ? "".concat(obj.username, ":").concat(obj.password, "@") : '';
    var auth = obj.auth ? obj.auth + '@' : '';
    var port = obj.port ? ':' + obj.port : '';
    var protocol = obj.protocol ? obj.protocol + '//' : '';
    var host = obj.host || '';
    var hostname = obj.hostname || '';
    var search = obj.search || (obj.query ? '?' + obj.query : '');
    var hash = obj.hash || '';
    var pathname = obj.pathname || ''; // @ts-ignore - path is not supported in node but we normalise

    var path = obj.path || pathname + search;
    return "".concat(protocol).concat(userPass || auth).concat(host || hostname + port).concat(path).concat(hash);
  }
}

module.exports = {
  URLWithLegacySupport: URLWithLegacySupport,
  URLSearchParams: self.URLSearchParams,
  defaultBase: defaultBase,
  format: format
};